import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { defaultContent } from "../config/siteConfig";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentContext = createContext({ content: defaultContent, loaded: false, reload: () => {} });

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

// Objecten worden samengevoegd, arrays (diensten, projecten, plaatsen) worden vervangen.
export const mergeContent = (base, override) => {
  if (!isObj(override)) return base;
  const out = { ...base };
  for (const key of Object.keys(override)) {
    const val = override[key];
    out[key] = isObj(val) && isObj(base?.[key]) ? mergeContent(base[key], val) : val;
  }
  return out;
};

// Afbeeldingen uit de opslag staan als "/api/files/<id>"; die moeten via de backend-URL geladen worden.
export const imgSrc = (src) =>
  src && src.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(defaultContent);
  const [loaded, setLoaded] = useState(false);

  const reload = async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent(mergeContent(defaultContent, data));
    } catch {
      setContent(defaultContent);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  return <ContentContext.Provider value={{ content, loaded, reload }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext).content;
export const useContentState = () => useContext(ContentContext);
